import { OrderEventInfo } from "../models/common";

export interface OrderStatusType {
  title: string;
  code: number;
  color: string;
}

export const OrderStatus: { [key: string]: OrderStatusType } = {
  ALL: {
    title: '全部',
    code: -2,
    color: '#808080', // 灰色
  },
  UNPAID: {
    title: '待支付',
    code: -1,
    color: '#ff9800', // 橙色
  },
  PENDING: {
    title: '待同意',
    code: 0,
    color: '#2196f3', // 蓝色
  },
  AGREED: {
    title: '已同意',
    code: 1,
    color: '#4caf50', // 绿色
  },
  LOADED: {
    title: '已装货',
    code: 2,
    color: '#00bcd4', // 青色
  },
  DELIVERED: {
    title: '已送达',
    code: 3,
    color: '#3f51b5', // 靛蓝色
  },
  COMPLETED: {
    title: '已完成',
    code: 4,
    color: '#009688', // 蓝绿色
  },
  CANCELLED: {
    title: '已取消',
    code: 80,
    color: '#9e9e9e', // 深灰色
  },
  EXCEPTION: {
    title: '异常',
    code: 99,
    color: '#f44336', // 红色
  },
  RESOLVED: {
    title: '已解决',
    code: 100,
    color: '#8bc34a', // 浅绿色
  },
};


export const getOrderEventsInfo = (events: OrderEventInfo[]): string => {
  if (!events || events.length === 0) {
    return "";
  }
  
  return events
    .map(event => {
      return `${getOrderStatusTitle(event.type)} : ${event.time}`;
    })
    .filter(Boolean)
    .join('\n');
};

// 获取状态颜色
export const getOrderStatusColor = (code: number): string => {
  const status = Object.values(OrderStatus).find(status => status.code === code);
  return status?.color || '#808080';
};

// 获取状态标题
export const getOrderStatusTitle = (code: number): string => {
  const status = Object.values(OrderStatus).find(status => status.code === code);
  return status?.title || '未知状态';

};

export default OrderStatus;
// {
//   "id": "6807112d3d202de96d8643be",
//   "cargo": {
//     "_id": "680705e03d202de96d8612f2",
//     "name": "A铁精粉",
//     "description": "盖好雨布",
//     "unit_price": 50,
//     "image": "https://guiyunbao-public.oss-cn-shanghai.aliyuncs.com/6636cae19675a5262aa0ccea/1729492194306-a98892ec-666f-494d-9257-5ed4ad95a8ba.jpg",
//     "expect_departure_at": "2025-04-22T03:58:00.000Z",
//     "status": 1,
//     "need_receipt": false,
//     "owner": "6636cae19675a5262aa0ccea",
//     "from": "67e0f5413d202de96d37e137",
//     "to": "680307a93d202de96d8054af",
//     "deposit": 200,
//     "deposit_refund": true,
//     "continuous": false,
//     "single_price": null,
//     "no_pre_billing": true,
//     "truck_lengths": [
//       2,
//       3
//     ],
//     "truck_types": [
//       3
//     ],
//     "createdAt": "2025-04-22T02:58:40.760Z",
//     "updatedAt": "2025-04-22T02:58:41.852Z"
//   },
//   "events": [
//     {
//       "type": 0,
//       "time": "2025-04-22T03:46:53.145Z"
//     },
//     {
//       "type": 1,
//       "time": "2025-04-22T03:51:48.387Z"
//     },
//     {
//       "type": 2,
//       "time": "2025-04-22T03:53:07.370Z"
//     }
//   ],
//   "from": {
//     "_id": "67e0f5413d202de96d37e137",
//     "name": "小卢 ",
//     "phone": "19976053171",
//     "province": "广西壮族自治区",
//     "city": "玉林市",
//     "district": "博白县",
//     "address": ".",
//     "latitude": 22.116958,
//     "longitude": 109.993125
//   },
//   "status": 2,
//   "to": {
//     "_id": "680307a93d202de96d8054af",
//     "name": "小卢",
//     "phone": "19976053171",
//     "province": "广西壮族自治区",
//     "city": "柳州市",
//     "district": "柳北区",
//     "address": ".",
//     "longitude": 109.411005,
//     "latitude": 24.328182
//   },
//   "truck": {
//     "_id": "68070d013d202de96d863440",
//     "plate": "豫QH5861",
//     "plate_color": 1,
//     "type": "13米 自卸",
//     "truck_type": 3,
//     "truck_length": 3,
//     "owner": "675adf3398cd3d1f0418eb49",
//     "createdAt": "2025-04-22T03:29:05.037Z",
//     "updatedAt": "2025-04-22T03:29:05.037Z",
//     "UpdatedAt": "0001-01-01T00:00:00.000Z",
//     "fee": 0,
//     "phone": ""
//   }
// }